/**
 * Hands a file made in the browser to the user as a download.
 *
 * The link is attached for the click because Firefox ignores a click on a
 * detached anchor, and the URL is revoked straight after because the browser
 * has taken its own copy of the file by then.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
